import { Box, SxProps } from '@mui/material';
import IphoneSwitchField from './IphoneSwitchField';
import { FormSwitchFieldProps } from '@dfl/mui-react-common';

type Props = FormSwitchFieldProps & {
  bg?: string;
  sxBox?: SxProps;
};

const FormCustomSwitchField = ({ bg, sxBox, ...props }: Props) => {
  return (
    <Box
      sx={{
        '.MuiFormControlLabel-root': {
          background: bg || '#F6F7F9 !important',
          marginLeft: '0px',
          alignItems: 'flex-start',
          padding: '9px 15px 9px 8px',
          borderRadius: '8px',
          flexDirection: 'row-reverse',
          gap: 2,
          width: '100%',
          justifyContent: 'space-between',
        },
        ...sxBox
      }}
    >
      <IphoneSwitchField {...props} />
    </Box>
  );
};

export default FormCustomSwitchField;
